import PageAccount from '@/components/PageAccount';

export default PageAccount;

export async function getStaticProps() {
  return {
    props: {
      path: '/registrierung',
      description:
        'Über LOTTO.de können Sie sich bei der Landeslotteriegesellschaft Ihres Bundeslandes registrieren und Ihre Spielscheine abgeben. ',
      variant: 'register',
      title: 'Registrierung auf LOTTO.de',
    },
  };
}
